(function (module) {
	'use strict';

	function contentScrollerLink(scope, element, attrs) {
		var cs = new contentScroller();
		cs.initContentScroller(element);
  }

	module.directive('contentscroller', function () {
		return {
			restrict: 'A',
			link: contentScrollerLink
		};
	});


})(angular.module('app'));
